import EnhancedTitleManager from './EnhancedTitleManager';

const TitleManager = () => {
  return <EnhancedTitleManager />;
};

export default TitleManager;